export default __webpack_public_path__ + "static/media/gym-card.db51328f.png";